/**
 * Semantic styles for the shared confirmation success header.
 *
 * Names describe the role of each element so the markup reads as a layout
 * outline rather than a wall of Tailwind utilities.
 */
export const confirmationSuccessHeaderStyles = {
  rootInline: 'flex w-full items-center gap-2 font-sans',
  rootStacked: 'flex w-full flex-col items-center justify-center gap-4 font-sans',
  icon: 'shrink-0 text-success',
  textBoxInline: 'flex flex-col',
  textBoxStacked: 'flex flex-col items-center gap-0.5 text-center',
  title: 'text-2xl font-semibold text-foreground',
  subtitle: 'text-base text-foreground',
};
